import { useEffect } from "react";
import { Link } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";


const Card = ({ styleName, title, num, lnk, loading }) => {

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    return (
        <div className={`card dashboardCard shadow border-0 ${styleName} overflow-hidden`}>
            <div className="card-body text-center card-font">
                <h4 className="card-title mb-4 pb-2">{title}</h4>
                <h3 className="card-text mb-4">
                    {loading && <SyncLoader color={"#000"} loading={loading} css={override} size={11} />}
                    {!loading && num}
                </h3>
                <Link to={lnk} className="card-link">View all</Link>
            </div>
        </div>
    )
}

export default Card;
